export function sortSelectOptions(options: { label: string; value: string }[]) {
  return options.sort((a, b) => a.label.localeCompare(b.label));
}
